<template>
  <header class="componentHeader "
    :class="{'border-bottom-1' :  $route.name !== 'login'}"
    :style="customStyleProps">
    <div class="headMain">
      <!-- <div class="left" v-if="document.referrer === ''">
        <slot name="home" />
      </div> -->
      <div class="left">
        <slot name="left" />
      </div>
      <div class="title">
        <slot name="title" />
      </div>
      <div class="search">
        <slot name="search" />
      </div>
      <div class="right">
        <slot name="right" />
      </div>
    </div>
  </header>
</template>
<script>
export default {
    name: 'acaHeader',
    props: {
        customStyleProps: { background: '#fff', color: '#333' },
    },
    watch: {
        customStyleProps (n) {
            if (n) {
                this.customStyle = { ...n }
            }
        }
    },
    data () {
        return {
            customStyle: {
                background: '#fff', color: '#333'
            }
        }
    }
}
</script>
<style lang="stylus" scoped>
$headerHeight = 88px
.componentHeader
  height $headerHeight
  width 100%
  background #fff
  position relative
  top 0
  left 0
  z-index 100
  font-size 36px
  text-align center
  color #333
  line-height $headerHeight
.headMain
  position absolute
  width 100%
  // height 90px
  left 0
  top 0
  z-index 10
  font-size 36px
  // box-shadow rgba(0,0,0, .3) 0 1px 4px
.title
  padding 0 80px
  height $headerHeight
  overflow hidden
  white-space nowrap
  text-overflow ellipsis
.search
  position absolute
  top 0
  left 0
  width 100%
  height $headerHeight
  z-index 80
.left, .right
  padding 0 10px
  position absolute
  top 0
  font-size 28px
  z-index 100
.left
  left 0
.right
  right 0
  padding 0 30px
</style>
